/**
 * Resolving a song question's answer text.
 *
 * A song's identity has been written two different ways over time:
 *   - split across songTitle + songArtist (older quizzes), or
 *   - as one "Title - Artist" string in the shared `answer` field, which is
 *     what the quiz editor now offers and what the answer-reveal slide reads.
 *
 * Every host-facing surface has to accept both, or a round authored one way
 * shows a blank answer key on the night — which is exactly what happened to
 * the audio rounds authored with `answer` only.
 */

export interface SongAnswerFields {
  answer?: string | null;
  songTitle?: string | null;
  songArtist?: string | null;
}

/**
 * Answer text for a song question, or '' when nothing has been filled in.
 * `answer` wins: it's the field the editor writes and the presentation
 * reveals, so it's the one that matches what the audience will see.
 */
export function songAnswerText(q: SongAnswerFields | null | undefined): string {
  if (!q) return '';
  const combined = [q.songTitle, q.songArtist].filter(Boolean).join(' — ');
  return q.answer || combined || '';
}
